import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../components/Home";
import Register from "../components/Register";
import Login from "../components/Login";
import Locations from "../components/Locations";
import Shop from "../components/Shop";
import Cart from "../components/Cart";
import Checkout from "../components/Checkout";
import Program from "../components/Program";
import Logout from "../components/Logout";
import Reset from "../components/Reset";
import ResetPassword from "../components/ResetPassword";
import About from "../components/About";
import FirstLogin from "../components/FirstLogin";
import Account from "../components/Account";
import Orders from "../components/Orders";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/first-login',
        name: 'FirstLogin',
        component: FirstLogin
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout
    },
    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/reset',
        name: 'Reset',
        component: Reset
    },
    {
        path: '/resetpassword/:token',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: '/locations',
        name: 'Locations',
        component: Locations
    },
    {
        path: '/program/:id',
        name: 'Program',
        component: Program
    },
    {
        path: '/register/:id?',
        name: 'Register',
        component: Register
    },
    {
        path: '/shop/:id?',
        name: 'Shop',
        component: Shop
    },
    {
        path: '/checkout/:id',
        name: 'Checkout',
        component: Checkout
    },
    {
        path: '/cart',
        name: 'Cart',
        component: Cart
    },
    {
        path: '/account',
        name: 'Account',
        component: Account
    },
    {
        path: '/orders',
        name: 'Orders',
        component: Orders
    }    
]

const router = new VueRouter({
                                 mode: 'history',
                                 base: process.env.BASE_URL,
                                 routes
                             })

export default router
